"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _user = _interopRequireDefault(require("cccisd-icons/user"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// TODO: add real actions for roles
var possibleActions = [{
  value: 'loginAs',
  label: 'Login As'
}, {
  value: 'delete',
  label: 'Delete'
}];
var _default = exports["default"] = {
  handle: 'rolesActions',
  label: 'General roles actions',
  isAction: true,
  applyToLevels: ['roles'],
  initialSettings: {
    actions: possibleActions.map(function (action) {
      return action.value;
    })
  },
  SettingsComponent: function SettingsComponent() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "actions",
      render: function render(_ref) {
        var field = _ref.field,
          form = _ref.form;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
          field: field,
          form: form,
          showErrorImmediately: true
        }, possibleActions.map(function (action) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: action.value,
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: function onChange() {
              form.setFieldValue('actions', (0, _xor2["default"])(field.value, [action.value]));
            },
            checked: field.value.includes(action.value)
          }), ' ', action.label));
        }));
      }
    });
  },
  validateSettings: function validateSettings(values) {
    var errors = {};
    if (values.actions.length === 0) {
      errors.actions = 'At least one action is required';
    }
    return errors;
  },
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref2) {
        var value = _ref2.value,
          row = _ref2.row;
        var actions = settings.actions;

        // TODO: add real button code
        var buttons = [];
        if (actions.includes('loginAs')) {
          buttons.push( /*#__PURE__*/_react["default"].createElement("button", {
            key: "loginAs",
            className: "btn btn-xs btn-success",
            type: "button"
          }, /*#__PURE__*/_react["default"].createElement(_user["default"], null)));
        }
        if (actions.includes('delete')) {
          buttons.push( /*#__PURE__*/_react["default"].createElement("button", {
            key: "delete",
            className: "btn btn-xs btn-danger",
            type: "button"
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttons
        }, buttons);
      }
    };
  }
};